import React, { useEffect, useState } from 'react'
import { makeStyles, useTheme } from '@seahorse/ui'
import { StackBarChart, Legend, BarChartOptions, LineChart, LineChartOptions } from '@seahorse/charts'
import { Dropdown } from '@seahorse/ui'
import { DateRangePicker } from '@seahorse/ui'
import { fetchNews,fetchChartData } from '../../Utils/Utils'



const mockGraphData = [
    {
        "x": "0/22",
        "y": 0.1,
        "y1": 2
    },
    {
        "x": "1/22",
        "y": 0.4,
        "y1": 0
    },
    {
        "x": "2/22",
        "y": 0.5,
        "y1": 0
    },
    {
        "x": "3/22",
        "y": 0.2,
        "y1": 0
    },
    {
        "x": "4/22",
        "y": -0.1
    },
    {
        "x": "5/22",
        "y": -0.2,
        "y1": 0
    },
    {
        "x": "6/22",
        "y": 0.3,
        "y1": 0
    },
    {
        "x": "7/22",
        "y": 0.4,
        "y1": 0
    },
    {
        "x": "8/22",
        "y": 0.6,
        "y1": 0
    },
    {
        "x": "9/22",
        "y": 0.5,
        "y1": 0
    },
    {
        "x": "10/22",
        "y": 0.6,
        "y1": -0.2
    },
    {
        "x": "11/22",
        "y": 0.8,
        "y1": 0.6
    },
    {
        "x": "12/22",
        "y": -0.1,
        "y1": 1
    }
]



const GeoWidget: React.FunctionComponent = () => {
    const linkStyle = {
        maxWidth: "200px", // Set a maximum width for the URL
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "inline-block", // Ensure it's treated as a block-level element for styling
    };


    const useStyles = makeStyles({
        wrapper: {
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridTemplateRows: 'auto 1fr',
            gridRowGap: 4,
            width: '100%',
        },
    })
    const classes = useStyles()
    const theme = useTheme()
    // const fluidFontSizeClassName = useFluidWidgetFontSizeClassName({ min: 10, max: 12 })

    const colors = {
        Pending: theme.globallink.colors.DataTurquoise[500],
        Ineligible: theme.globallink.colors.DataOrange[500],
        Cleared: theme.globallink.colors.DataPurple[500],
        Rejected: theme.globallink.colors.DataAmber[600],
    }

    const [selectedCompany, setSelectedCompany] = useState("Bharatiya Janata Party")
    const [newsArticles, setNewsArticles] = useState([])
    const [filter1, setFilter1] = useState([])
    const [chartData, setChartData] = useState(mockGraphData)
    const [selectedFilterOption, setSelectedFilterOption] = useState({
        selectedCountries: [],
        selectedCompanies: [],
        selectedIsin: [],
    })

    const legendItems = [
        {
            key: selectedCompany,
            label: selectedCompany,
        },
    ]
    useEffect(() => {
        fetchNews(setNewsArticles)
        fetchChartData(setChartData,setFilter1)
    }, [])

    
    const optionsLine: LineChartOptions = {
        showGradient: false,
        strokeWidth: 3,
        lineColor: "#43CFE6",
        chartName: "Risk Analysis Chart",

        xAxis: {
            dataKey: "x",

            "tickSize": 2,
            "maxTickCount": 7,
            "tickLineColor": "#43CFE6",
            "tickLineWidth": 2
        },
        yAxis: {
            dataKey: selectedCompany,
        }

    }



    const DropdownItem = [
        {
            "label": "Indian PM",
            "value": "Indian PM"
        },
        {
            "label": "Indian Rupee",
            "value": "Indian Rupee"
        },
        {
            "label": "Indian National Congress",
            "value": "Indian National Congress"
        },
        {
            "label": "PNOTES",
            "value": "PNOTES"
        },
        {
            "label": "RBI",
            "value": "RBI"
        },
        {
            "label": "Monsoon",
            "value": "Monsoon"
        },
        {
            "label": "Interest Rate",
            "value": "Interest Rate"
        },
        {
            "label": "Derivatives Market",
            "value": "Derivatives Market"
        },
        {
            "label": "Rahul Gandhi",
            "value": "Rahul Gandhi"
        },
        {
            "label": "FDI",
            "value": "FDI"
        },
        {
            "label": "FPI",
            "value": "FPI"
        },
        {
            "label": "IPO",
            "value": "IPO"
        },
        {
            "label": "Imports",
            "value": "Imports"
        },
        {
            "label": "GDP",
            "value": "GDP"
        },
        {
            "label": "Foreign Exchange Reserves",
            "value": "Foreign Exchange Reserves"
        },
        {
            "label": "Stock Market",
            "value": "Stock Market"
        },
        {
            "label": "Budget",
            "value": "Budget"
        },
        {
            "label": "Economy",
            "value": "Economy"
        },
        {
            "label": "Export Restrictions",
            "value": "Export Restrictions"
        },
        {
            "label": "Indian Opposition Party",
            "value": "Indian Opposition Party"
        },
        {
            "label": "Bharatiya Janata Party",
            "value": "Bharatiya Janata Party"
        },
        {
            "label": "ETCD",
            "value": "ETCD"
        },
        {
            "label": "Exports",
            "value": "Exports"
        },
        {
            "label": "Debt",
            "value": "Debt"
        },
        {
            "label": "Bond Index",
            "value": "Bond Index"
        },
        {
            "label": "Inflation",
            "value": "Inflation"
        },
        {
            "label": "P Chidambaram",
            "value": "P Chidambaram"
        },
        {
            "label": "Deficit",
            "value": "Deficit"
        },
        {
            "label": "Bond Market",
            "value": "Bond Market"
        }
    ]

    return (<>
        <div className=' h-100 w-100 p-2 '>

            <div>
                {/* <h6 className='mb-2'> */}
                    GeoPolitical India
                {/* </h6> */}
            </div>
            <div className='d-flex justify-content-between align-items-center '>
                {/* <DateRangePicker locale={"en"} className='w-50 p-2' filterDate={(date: Date) => (date >= new Date("2017-01-01"))} minDate={new Date("2017-01-01")} maxDate={new Date()} monthsShown={2} excludeDates={[new Date()]} /> */}
                {/* <Dropdown items={DropdownItem} onChange={y => setSelectedCompany(y)} value={selectedCompany} className='w-50 p-2' /> */}
                {/* <Dropdown items={DropdownItem} onChange={y => setSelectedCompany(y)} value={selectedCompany} className='w-50 p-2' /> */}
                {/* <Dropdown items={DropdownItem} onChange={y => setSelectedCompany(y)} value={selectedCompany} className='w-50 p-2' />
                <Dropdown items={DropdownItem} onChange={y => setSelectedCompany(y)} value={selectedCompany} className='w-50 p-2' /> */}
                <>

                </>

            </div>
            {/* {"Selected : " + selectedCompany}  */}
            {/* <h6>  {"Selected : " + selectedCompany}  </h6> */}
            {/* <Legend items={legendItems} colors={colors} size="large" /> */}
            <LineChart data={chartData} options={optionsLine} />
            
        </div>
    </>

    )
}

export default GeoWidget
